import { Link } from "react-router-dom";

const FAMILY_LINKS = [
  { name: "RAW Company Tech (Hub)", url: "https://rawcompanytech.com" },
  { name: "Live Gold Signals (Trading)", url: "https://rawcompanytech.com/trading" },
  { name: "Snapdog (UK Dog Network)", url: "https://dogsnap.co.uk" },
  { name: "Raw Mixes (DJ Mixes)", url: "https://rawmixes.uk" },
  { name: "Racing Form Guide", url: "https://racingformguide.co.uk" },
  { name: "RAW Data (Wealth Analytics)", url: "https://raw-data.uk" },
];

export default function RawCompanyFooter() {
  return (
    <footer data-testid="raw-company-footer" className="bg-[#0a0a0a] text-white mt-8">
      {/* Main content */}
      <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-10 grid grid-cols-1 md:grid-cols-3 gap-8">
        {/* Section 1 - About */}
        <div>
          <h3 className="text-[#D4AF37] text-lg mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>
            Part of RAW Company Tech
          </h3>
          <p className="text-sm text-zinc-400 leading-relaxed mb-4">
            Racing Form Guide is one brand in the RAW COMPANY TECH LIMITED family — an independent UK software lab (Companies House No. 17349121, England & Wales, director Lee Raw) building apps, games and premium products, all engineered in-house.
          </p>
          <a
            href="https://rawcompanytech.com/empire"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block border border-[#D4AF37] text-[#D4AF37] text-xs font-mono uppercase tracking-wider px-4 py-2 hover:bg-[#D4AF37] hover:text-black transition-colors"
          >
            Visit the whole empire &rarr;
          </a>
        </div>

        {/* Section 2 - Family links */}
        <div>
          <h3 className="text-[#D4AF37] text-lg mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>
            More from RAW Company
          </h3>
          <ul className="space-y-2">
            {FAMILY_LINKS.map((link) => (
              <li key={link.url}>
                <a
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-zinc-400 hover:text-[#D4AF37] transition-colors"
                >
                  {link.name}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Section 3 - Contact */}
        <div>
          <h3 className="text-[#D4AF37] text-lg mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>
            Contact
          </h3>
          <div className="space-y-2 text-sm text-zinc-400">
            <p><a href="mailto:orders@rawcompanytech.com" className="hover:text-[#D4AF37] transition-colors">orders@rawcompanytech.com</a></p>
            <p><a href="tel:07398238509" className="hover:text-[#D4AF37] transition-colors">07398 238 509</a></p>
          </div>
        </div>
      </div>

      {/* Bottom strip */}
      <div className="border-t border-zinc-800 py-4 px-4 md:px-8">
        <div className="max-w-[1400px] mx-auto flex flex-wrap items-center justify-between gap-2 text-[10px] text-zinc-500">
          <p>&copy; {new Date().getFullYear()} RAW COMPANY TECH LIMITED &middot; All Rights Reserved</p>
          <p>
            An official product of{" "}
            <a href="https://rawcompanytech.com" target="_blank" rel="noopener noreferrer" className="text-[#D4AF37] hover:underline">
              RAW COMPANY TECH LIMITED
            </a>
            . Registered in England & Wales (
            <a href="https://find-and-update.company-information.service.gov.uk/company/17349121" target="_blank" rel="noopener noreferrer" className="text-zinc-400 hover:text-[#D4AF37]">
              Company No. 17349121
            </a>
            ).
          </p>
        </div>
        <div className="max-w-[1400px] mx-auto mt-2 text-[10px] text-zinc-600 text-center">
          Race data provided by The Racing API. Win chance percentages are calculated predictions for informational purposes only.
        </div>
      </div>
    </footer>
  );
}
